export default {
  route: {
    home: '首页',
    profile: '个人中心',
    product: '商品管理',
    productOnlineManage: '线上商品管理',
    productUnderManage: '线下商品管理',
    productCombination:'组合商品管理',
    productOnlineReview:'线上商品审核',
    productSettle: '费率设置',
    productSettleDetail:'费率设置-商品',
    addOnLineProduct: '新增线上商品',
    seller: '商户管理',
    sellerList: '主商户管理',
    sellerApprove: '商户审批',
    arrears:'欠款管理',
    arrearsOrder:'欠款还款账单',
    arrearsOrderDetail:'欠款还款账单详情',
    sellerSubordinate: '子商户管理',
    sellerRelation: '关系管理',
    shopMemberCard:'商户会员卡管理',
    operation: '运营管理',
    liveBroadcast: '直播列表',
    socialGroup: '社群列表',
    socialGroupDynamic: '社群动态列表',
    depositList: '保证金管理',
    depositDetail:'保证金详情',
    memberManage: '会员管理',
    memberList: '会员列表',
    memberDetail:'会员详情',
    memberPoint: '会员积分',
    memberSettle:'会员入驻管理',
    memberAuthentica: '认证审核',
    memberAuditDetail:'认证审核详情',
    manageType: '会员经营类型管理',
    reportConfig: '会员消费分级',
    assetManage: '资产管理',
    settleManage: '结算管理',
    reconciManage: '钱包充值对账',
    billManage: '账单管理',
    withdrawManage: '提现管理',
    userRechargeOrder: '充值订单管理',
    userCashTopUp: '用户现金充值',
    reportDownload: '微信对账单下载',
    summaryManagement:'充值汇总管理',
    topUpOrderCancel:'充值订单撤回',
    redRush: '红冲',
    reductionManage: '红冲审核',
    invoicingAuditList:'开票审核',
    invoicingDetail:'开票审核详情',
    feeManage:'费用管理',
    withdrawMonitor:'提现监控大盘',
    staBalance:'STA会员余额',
    staSettle:'STA供应商结算',
    marketingManage: '营销管理',
    activityList: '活动列表',
    activityAuditList: '活动审核列表',
    redpacketList: '红包列表',
    redpacketAuditList: '红包审核列表',
    redpacketTrackList: '红包跟踪列表',
    couponsList: '优惠券列表',
    couponsAuditList: '优惠券审核列表',
    couponsTrackList: '优惠券跟踪列表',
    issueList: '红包/优惠券发放',
    issueAuditList: '红包/优惠券发放审核',
    shortActivity: '燊鲜GO',
    summaryData: '活动汇总数据',
    blackList: '黑名单维护',
    priceContrast: '价格对比',
    couponList:'卡券列表',
    addCoupon:'新增卡券',
    couponActivity:'发券活动',
    addActivity:'新增活动',
    editActivity:'编辑活动',
    drawCouponList:'领券记录',
    pointsList:'积分活动',
    pointsAdd:'新增/编辑积分活动',
    buyGiftList:'买赠活动',
    buyGiftRules:'买赠活动规则',
    rebateAct:'返利活动',
    markupList:'加价购活动',
    markupAdd:'新增/编辑/查看加价购活动',
    secKillAct:'秒杀活动',
    secKillAdd:'新增/编辑/查看/引用秒杀活动',
    secKillTime:'秒杀时间配置',
    getCouponActivity:'领券活动',
    getCouponActAdd:'新增领券活动',
    promoRecommend:'推荐管理',
    promoRecommendProduct:'推荐商品',
    actProductPageConfig:'活动商品页面配置',
    actProductPageConfigAdd:'新增活动商品页面配置',
    marketingFee:'营销费用账单',
    shopWithdraw:'商户提现资产',
    category: '品类管理',
    sysCategory: '系统分类维护',
    virtualCategory: '虚拟品类维护',
    sys: '系统管理',
    menuList: '菜单列表',
    roleList: '角色管理',
    adminList: '平台操作员管理',
    shopAdminListManage: '商户员工管理',
    configManage: '配置管理',
    logistics: '物流方管理',
    specialCommoditySettlement: '特殊商品结算',
    whiteList: '白名单列表',
    msgList: '消息配置列表',
    delayList: '定时器补偿',
    afterWhyList: '关单售后原因配置',
    warehouse: '线下商品批量管理',
    businessConfig: '业务配置',
    config: '配置管理',
    configList: '配置列表',
    faqList: '常见问题管理',
    searchList: '搜索配置',
    agreementList: '协议管理',
    reprintReason: '补打原因配置',
    deliveryManager:'配送管理',
    tagList:'标签管理',
    purchaseConfig: '采小助配置管理',
    sundry: '杂项配置',
    placeList: '产地管理',
    productIssues:'出门扫码商品问题配置',
    keyConfig:'重点商户商品配置',
    categoryManager:'品类统计配置',
    popularManager:'热门行情配置',
    marketConfig:'市场行情配置',
    accountList: '账号管理',
    aftersale: '售后管理',
    aftersaleOrder: '售后单维护',
    refundOrder: '退款单维护',
    orderManage: '订单管理',
    cityWholesalerOrder: '城市批发商订单',
    cityDetailNew: '订单详情',
    warehouseOrderList:'仓库单管理',
    originDealerOrder: '产地经销商订单',
    pageConfig: '页面配置',
    floorConfig: '商城页面配置',
    advertConfig: '广告图管理',
    goodsRecommend: '楼层管理',
    cateConfig:'分类页配置',
    guideCateConfig:'商户分类配置',
    informationList: '资讯列表',
    logisticsDelivery:'物流派送',
    logisticsOrderManag:'物流单管理',
    transferDistribution:'中转仓分配',
    printDispatch:'补打派送清单',
    freightManage: '运费管理',
    scanIndex:'物流扫码',
    quickAllocation:'快捷分配',
    orderLogistics:'订单物流',
    addressModify:'地址管理',
    alreadyAssigned:'AI司机排单',
    alreadyAssignedDetail:'AI司机排单 · 详情/修改',
    mapIndex:'移动轨迹',
    shopCombination:'自定义商户组合',
    addressUpdateAudit:'地址修正审核',
    spotCheckIndex:'质检配置',

    logisticsCostRule:"物流费用规则",
    areaList:'外围区域设置',
    modelList:'车型满载率维护',
    costRuleList:'费用规则设置',
    driverRuleList:'司机规则绑定',
    costCustomList:'自定义费用',
    costStatistics:'费用统计',


    businessCircleNews:'生意圈资讯',
    clientManage: '客户管理',
    relationManage: '客户关系管理',
    promoterManage: '推广员管理',
    businessManager:'业务员管理',
    business:'推广员管理',
    lsManager:'物流员管理',
    councilManager:'场内理事管理',
    purchaseHelper: '采小助商品管理',
    purchaseCategory: '采小助分类管理',
    purchaseRecommend: '采小助商品推荐',
    purchaseSummary: '采小助汇总管理',
    unrecordedSummary: '未录入汇总',
    quotationManage: '报价单管理',
    productDraft:'草稿',
    reportList:'市场管理',
    superMember:'超级会员日(会员)',
    blackListMember:'超级会员日(黑名单)',
    superMemberShang:'超级会员日(商户)',
    treatyList:'协议管理',
    treatyAudit:'协议审核',
    operateList:'操作记录',
    scanList:'离场登记',
    scanListFlow:'离场登记流水',

    // 三方业务菜单
    tripartiteBiz: '外部订单管理',
    tripartiteOrder: '外部订单列表',
    tripartiteTransfer: '外部中转仓列表',
    tripartiteFreight: '外部物流单列表',

    //CRM工单相关
    visitManage: '管家拜访管理',
    workOrderManage: '拜访工单管理',
    askConfig:'工单问询配置',

    //report报表相关菜单
    finance:"财务管理",
    posWithdraw:"商户可提现",
    dailySales:"日销售明细",
    withdrawalIncidental:"提现杂费管理",
    financeLogistics:"财务用物流报表",
    financeLogisticsDetail:"物流明细报表",
    memberBalance:'会员余额',
    realTimeData:'实时数据',
    creditList:'赊账订单管理',
    fund:'资金对账',
    fundDaily:'会员卡日报表',
    capitalDaily:'资金日报表',
    shopDaily:'商户交易日报',
    categorySum:'品种汇总表',
    serviceRate:'服务费率报表',
    productSales:'商品销售明细',
    shopWithdrawalSum:'商户提现汇总',
    productWithdrawalSum:'提现商品汇总',
    productWithdrawalDetail:'提现商品明细',
    mileageFreight:"里程运费报表",
    newLogisticsDetail:'物流明细报表(新)',
    rebateList:'活动返利报表',
    wxAccount:'微信对账',
    icbcAccount:'聚合支付对账',
    dataBoard:'数据分析',
    dataBoardData:'实时数据',

    lottery:'抽奖活动',
    lotteryIndex:'抽奖活动',
    lotteryList:'登记记录',
    thermodynamicDiagram:"物流区域配置",
    thermData:"会员采购热力分析",
    marketingExpenseBill:'营销费用账单',
    outRegistLog:'异常核验记录'
  },
  navbar: {
    welcome: '欢迎',
    home: '首页',
    logOut: '退出登录',
    profile: '个人中心'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  components: {
    documentation: '文档',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
  },
  table: {
    add: '添加',
    audit: '审核',
    bind: '绑定',
    cancel: '取消',
    confirm: '确定',
    draft: '草稿',
    delete: '删除',
    disable: '禁用',
    detail: '详情',
    export: '导出',
    edit: '修改',
    enable: '启用',
    import: '导入',
    list: '查询',
    reset: '重置',
    update: '更新'
  },
  permsbtns: {
    add: '新增',
    create: '新增',
    update: '更新',
    list: '列表',
    query: '查询',
    disable: '禁用',
    enable: '启用',
    audit: '审核',
    delete: '删除',
    detail: '详情',
    import: '导入',
    modify: '修改',
    move: '位置排序',
    enabled: '启用',
    withdraw: '提现',
    confirm: '对账',
    export: '导出',
    endlivebroadcast: '关闭直播',
    look: '详情',
    enableDisable: '启用和禁用',
    trendDisable: '删除和禁用',
    submit: '提交',
    trace: '跟踪',
    defriend: '拉黑',
    restpwd: '重置密码',
    addType: '新增类型',
    addWen: '新增问题',
    indexFoorConfig: '楼层配置',
    addTag: '新增标签分类',
    drop: '作废资讯',
    release: '发布资讯',
    accessDeal: '处理',
    charge: '充值',
    channellist: '渠道列表',
    updatePhone: '更新手机号',
    pwd: '密码操作',
    auth: '实名认证',
    card: '会员卡操作',
    bind: '绑定',
    unbind: '解绑',
    publish: '上架',
    unpublish: '下架',
    redRush: '红冲',
    close: '关闭',
    execManual: '清分',
    maintainScale: '维护电子秤商品',
    shopList: '商户返现列表',
    platformList: '平台返现列表',
    auditList: '财务审批列表',
    shopExport: '商户返现导出',
    platformExport: '平台返现导出',
    listExport: '财务审批导出',
    blackListImport: '黑名单导入',
    blackListExport: '黑名单导出',
    start:'发车',
    confirms:'中转确认',
    typeDelete:'资讯分类删除',
    typeAdd:'新增分类资讯',
    migratel:'迁移',
    reverse:'撤销',
    print: "打印",
    rateApproved:'财务审批',
    remove:'删除',
    send: '发货',
    changeDriver: '修改司机',
    printSendList: '打印发货数据',
    authForShop:'代商户审核',
    reductionJcAuth: '审核',
    reductionCwOperate: '红冲',
    secKillDisable: '禁用',
    secKillAdd: '新增',
    secKillUpdate: '修改',
    secKillEnable: '启用',
    secKillDrop: '作废',
    getCouponActEnable: '启用',
    getCouponActDisable: '禁用',
    recommendConfigUpdate: '修改',
    recommendConfigAdd: '新增',
    recommendProductUpdate:'维护',
    updateOperateType:'编辑经营类型',
    stockSync:'库存同步',
    alreadyAssignedEdit:'未确认编辑',
    alreadyAssignedConfirmedEdit:'已确认编辑',
    alreadyAssignedDelete:'删除',
    alreadyAssignedConfirm:'确认',
    invalid:'协议作废',
    end:'解约',
    track:'配送轨迹',
    afterSale: '发起售后',
    shopConfirm:'确认退款',
    logisticsConfirm:'物流确认',
    takeBackConfirm:'确认带回',
    uploadVoucher:'上传凭证',
    invoicingConfirm:'确认开票',
    invoicingClose:'关闭开票',
    invoicingUpdateFile:'修改发票文件',
    systemSend:'卡券发放类型',
    registrationFee:'费用登记',
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js